import { createReducer } from '@reduxjs/toolkit';
import {
    SET_SINGLE_PROMOTION_DATA, SET_LAST_SLUG,
    SET_LAST_PROMOTION_WINNERS_ID, SET_PROMOTION_WINNERS,
    SET_USER_ANWSER, SET_LAST_USER_ANSWER,
    IS_FETCHING, END_FETCHING,
    RESET_PROMOTION_DATA, SET_NOT_FOUND,
} from '../actions/SinglePromotionsActions';

const initialState = {
    singlePromotionData: {},
    lastSlug: null,
    lastPromotionWinnerId: null,
    promotionWinnersData: [],
    userAnswer: [],
    isFetching: false,
    lastPromotionAnswer: null,
    notFound: false,
};

const singlePromotions = createReducer(initialState, (builder) => {
    builder
        .addCase(SET_SINGLE_PROMOTION_DATA, (state, action) => {
            state.singlePromotionData = action.data;
        })
        .addCase(SET_LAST_SLUG, (state, action) => {
            state.lastSlug = action.data;
        })
        .addCase(SET_LAST_PROMOTION_WINNERS_ID, (state, action) => {
            state.lastPromotionWinnerId = action.data;
        })
        .addCase(SET_PROMOTION_WINNERS, (state, action) => {
            state.promotionWinnersData = action.data;
        })
        .addCase(SET_USER_ANWSER, (state, action) => {
            state.userAnswer = action.data;
        })
        .addCase(SET_LAST_USER_ANSWER, (state, action) => {
            state.lastPromotionAnswer = action.data;
        })
        .addCase(IS_FETCHING, (state) => {
            state.isFetching = true;
        })
        .addCase(END_FETCHING, (state) => {
            state.isFetching = false;
        })
        .addCase(RESET_PROMOTION_DATA, (state) => {
            state.promotionWinnersData = [];
            state.lastPromotionWinnerId = null;
            state.userAnswer = [];
        })
        .addCase(SET_NOT_FOUND, (state, action) => {
            state.notFound = action.notFound;
        });
});

export default singlePromotions;
